export default {
  getImages: (state) => state.images,
  getImagesIsError: (state) => state.status.isError,
  getImagesError: (state) => state.status.error,
  getImagesIsLoading: (state) => state.status.isLoading
};
